// extracted by mini-css-extract-plugin
module.exports = {"tab":"TabItem_tab__Igr9_","button":"TabItem_button__oq_Dj","button__selected":"TabItem_button__selected__o_M3L"};